import IntroTyping from "../modules/intro-typing";
import heroData from "../data/hero-data";

class HeroSection extends HTMLElement {
  connectedCallback() {
    const {
      greeting,
      name,
      typingStrings,
      bio,
      profileImage,
      profileAlt,
      resumeCta,
      resumeLink,
      contactCta,
      contactLink,
    } = heroData;

    this.innerHTML = `
      <section
        class="grid min-h-[calc(100dvh-72px)] gap-y-5 items-start gap-x-[40px] px-[20px] pb-20 lg:min-h-[calc(100dvh-100px)] xl:grid-flow-col xl:grid-cols-[2fr_1fr] xl:grid-rows-2 xl:px-[150px] xl:gap-y-0"
        id="about"
      >
        <h2 class="flex flex-col self-center pt-4 lg:pt-12">
          <span>${greeting}</span>
          <span>${name}</span>
          <span
            ><span>a </span><span id="typing"></span><span id="cursor"></span
          ></span>
        </h2>
        <div class="my-6 ml-4 flex flex-col items-start gap-4 lg:ml-0 xl:mr-30">
          <p
            class="border-l-10 border-slate-500 px-10 py-5 text-base/normal lg:text-lg/normal xl:text-xl/normal"
          >
            ${bio}
          </p>
          <a
            class="cta-button cta-button--secondary ml-10 text-base lg:text-lg xl:text-xl"
            href="${resumeLink}"
            target="_blank"
            rel="noopener noreferrer"
            >${resumeCta}</a
          >
        </div>
        <div
          class="flex flex-col items-center gap-[56px] justify-self-center lg:gap-[80px] xl:row-span-full xl:mt-[130px] xl:gap-[100px]"
        >
          <div class="relative w-full max-w-[220px] sm:max-w-[260px] xl:max-w-[300px]">
            <img
              src="${profileImage}"
              alt="${profileAlt}"
              class="block w-full rounded-sm"
            />
            <div
              class="shadowing absolute top-4 left-4 -z-1 size-full rounded-sm bg-slate-500 xl:top-5 xl:left-5"
            ></div>
          </div>
          <nav>
            <a
              class="cta-button cta-button--primary text-xl xl:text-3xl"
              href="${contactLink}"
              >${contactCta}</a
            >
          </nav>
        </div>
      </section>
    `;

    const introTyping = new IntroTyping(typingStrings, 40);
    const typingEl = this.querySelector("#typing");
    const cursorEl = this.querySelector("#cursor");

    this.typingInterval = setInterval(() => {
      introTyping.type();
      if (typingEl) typingEl.textContent = introTyping.typedString;
      if (cursorEl) cursorEl.textContent = introTyping.cursor;
    }, 100);
  }

  disconnectedCallback() {
    if (this.typingInterval) {
      clearInterval(this.typingInterval);
    }
  }
}

customElements.define("hero-section", HeroSection);
